/**
 * Created by andrey on 25.09.2025
 */

const CloudStorageInterface = function () {
    return {
        resolve: function (choose = "equals") {
            connector._cloudStorage.resolve(choose);
        },

        hasConflict: function () {
            return connector._cloudStorage.hasConflict();
        },

        isEnabled: function () {
            return connector._cloudStorage.isEnabled();
        },

        on: function (eventName, callback) {
            connector._cloudStorage.bus.on(eventName, callback);
        },

        getLocalStorage: function () {
            return connector._cloudStorage.getLocalStorage();
        },

        getCloudStorage: function () {
            return connector._cloudStorage.getCloudStorage();
        }

        // setItem: function (eventName, callback) {
        //
        // },
        //
        // getItem: function (eventName, callback) {
        //
        // }
    };
};